import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	rename: {
		id: 'dashboard-edit.gadget-editable.rename',
		defaultMessage: 'Rename {gadgetName}',
		description:
			'This text is not visible and is used for accessibility purposes. It is attached to a hidden button on the title of a gadget. When it is clicked, an input box will open in place for the user to rename the gadget title.',
	},
});
